export type PrimaryNavId = 'map' | 'leagues' | 'play' | 'county' | 'news';

export interface PrimaryNavItem {
    id: PrimaryNavId;
    labelKey: string;
    defaultLabel: string;
    /** Static path, or null when resolved at render (legacy Map → last league). */
    path: string | null;
    match: (pathname: string) => boolean;
}

/** Primary chrome: Map is the product home. Other hubs stay linked but secondary. */
export const PRIMARY_NAV: PrimaryNavItem[] = [
    {
        id: 'map',
        labelKey: 'nav.map',
        defaultLabel: 'Map',
        path: '/',
        match: (p) =>
            p === '/' ||
            p.startsWith('/lab/own-map') ||
            p.startsWith('/league/') ||
            p === '/ufc' ||
            p.startsWith('/ufc/') ||
            p.startsWith('/naming-wars'),
    },
    {
        id: 'leagues',
        labelKey: 'nav.leagues',
        defaultLabel: 'Leagues',
        path: '/leagues',
        match: (p) => p === '/leagues' || p.startsWith('/leagues/') || p === '/classic',
    },
    {
        id: 'play',
        labelKey: 'nav.play',
        defaultLabel: 'Play',
        path: '/play',
        match: (p) =>
            p === '/play' ||
            p.startsWith('/survivor') ||
            p.startsWith('/fantasy') ||
            p.startsWith('/treasury') ||
            p.startsWith('/fans') ||
            p.startsWith('/rivalry') ||
            p.startsWith('/enlist') ||
            p.startsWith('/soldier') ||
            p.startsWith('/war-room') ||
            p.startsWith('/legion') ||
            p.startsWith('/hall/') ||
            p.startsWith('/battalion/') ||
            p.startsWith('/s/'),
    },
    {
        id: 'county',
        labelKey: 'nav.myCounty',
        defaultLabel: 'My County',
        path: '/my-county',
        match: (p) =>
            p === '/my-county' ||
            p.startsWith('/who-owns/') ||
            p === '/me' ||
            p.startsWith('/chronicle'),
    },
    {
        id: 'news',
        labelKey: 'nav.news',
        defaultLabel: 'News',
        path: '/news',
        match: (p) =>
            p === '/news' ||
            p === '/feed' ||
            p.startsWith('/forum') ||
            p.startsWith('/guides') ||
            p.startsWith('/social/'),
    },
];

/** Attic features — kept in app, not on the front porch. */
export const MORE_NAV: { label: string; path: string }[] = [
    { label: 'Enlist', path: '/enlist' },
    { label: 'War schedule', path: '/war-room' },
    { label: 'War Chronicle', path: '/chronicle/war' },
    { label: 'Classic homepage', path: '/classic' },
    { label: 'Mapbox live map', path: '/league/ncaa_basketball' },
    { label: 'All leagues', path: '/leagues' },
    { label: 'Play', path: '/play' },
    { label: 'My County', path: '/my-county' },
    { label: 'News', path: '/news' },
];
